class ForcastReportAction {
    static FORCAST_ACCURACY_ANALYTICS_REQUEST = "FORCAST_ACCURACY_ANALYTICS_REQUEST";
    static FORCAST_ACCURACY_ANALYTICS_SUCCESSFUL = "FORCAST_ACCURACY_ANALYTICS_SUCCESSFUL";
    static FORCAST_ACCURACY_ANALYTICS_FAILED = "FORCAST_ACCURACY_ANALYTICS_FAILED";

    static FORCAST_ACCURACY_ANALYTICS_LATEST_REQUEST = "FORCAST_ACCURACY_ANALYTICS_LATEST_REQUEST";
    static FORCAST_ACCURACY_ANALYTICS_LATEST_SUCCESSFUL = "FORCAST_ACCURACY_ANALYTICS_LATEST_SUCCESSFUL";
    static FORCAST_ACCURACY_ANALYTICS_LATEST_FAILED = "FORCAST_ACCURACY_ANALYTICS_LATEST_FAILED";

    static FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_REQUEST = "FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_REQUEST";
    static FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_SUCCESSFUL = "FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_SUCCESSFUL";
    static FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_FAILED = "FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_FAILED";

    static FORCAST_DETAILS_REQUEST = "FORCAST_DETAILS_REQUEST";
    static FORCAST_DETAILS_SUCCESSFUL = "FORCAST_DETAILS_SUCCESSFUL";
    static FORCAST_DETAILS_FAILED = "FORCAST_DETAILS_FAILED";

    static forcastaccuracyRequest() {
        return {
            type: this.FORCAST_ACCURACY_ANALYTICS_REQUEST
        };
    }
    static forcastaccuracySuccessul(data) {
        return {
            type: this.FORCAST_ACCURACY_ANALYTICS_SUCCESSFUL,
            data
        };
    }
    static forcastaccuracyFailed(error) {
        return {
            type: this.FORCAST_ACCURACY_ANALYTICS_FAILED,
            error
        };
    }

    // forecastaccuracy v2 
    static forcastaccuracyv2Request() {
        return {
            type: this.FORCAST_ACCURACY_ANALYTICS_LATEST_REQUEST
        };
    }
    static forcastaccuracyv2Successul(data) {
        return {
            type: this.FORCAST_ACCURACY_ANALYTICS_LATEST_SUCCESSFUL,
            data
        };
    }
    static forcastaccuracyv2Failed(error) {
        return {
            type: this.FORCAST_ACCURACY_ANALYTICS_LATEST_FAILED,
            error
        };
    }

    //human internention 
    static forcastaccuracyv2humanRequest() {
        return {
            type: this.FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_REQUEST
        };
    }
    static forcastaccuracyv2humanSuccessul(data) {
        return {
            type: this.FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_SUCCESSFUL,
            data
        };
    }
    static forcastaccuracyv2humanFailed(error) {
        return {
            type: this.FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_FAILED,
            error
        };
    }
    //
    
    static forcastdetailsRequest() {
        return {
            type: this.FORCAST_DETAILS_REQUEST
        };
    }
    static forcastdetailsSuccessful(data) {
        return {
            type: this.FORCAST_DETAILS_SUCCESSFUL,
            data
        };
    }
    static forcastdetailsFailed(error) {
        return {
            type: this.FORCAST_DETAILS_FAILED,
            error
        };
    }
}

export default ForcastReportAction;
